export const downloadCampaignGuide = () => {
    const file_path = 'https://connect-static.borrowbox.com/BorrowBox_Campaign_Guide_CONFIDENTIAL.pdf';
    const a = document.createElement('A') as HTMLAnchorElement;
    a.href = file_path;
    a.download = 'BorrowBox_Campaign_Guide_CONFIDENTIAL.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
